import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from '@environments/environment';
import { Connector, Log, Result } from '@app/_models';
import { types, authconfiguration, OauthTypeConfiguration } from '@app/_models';

@Injectable({ providedIn: 'root' })
export class ConnectorService {
  private connectorSubject: BehaviorSubject<Connector>;
  public connector: Observable<Connector>;
 
  constructor(
    private http: HttpClient
  ) {
    this.connectorSubject = new BehaviorSubject<Connector>(JSON.parse(localStorage.getItem('connectors')));
    this.connector = this.connectorSubject.asObservable();
  }

  public get connectorValue(): Connector {
    return this.connectorSubject.value;
  }

  create(connector: Connector) {
    return this.http.post<Result>(`${environment.apiUrl}/connector/addconnector`, connector);
  }

  getAll() {
    return this.http.get<Connector[]>(`${environment.apiUrl}/connector/getconnectors`);
  }

  getById(uId: string) {
    return this.http.get<Connector>(`${environment.apiUrl}/connector/getconnector?uid=${uId}`);
  }

  update(connector: Connector) {
    return this.http.post<Result>(`${environment.apiUrl}/connector/updateconnector`, connector);
  }

  remove(uId: string) {
    let httpheaders = new HttpHeaders({
      'content-type': 'application/json'

    });
    return this.http.post<Result>(`${environment.apiUrl}/connector/Removeconnector?uid=${uId}` , uId);
  }

  
  publish(uId: string) {
   
    return this.http.post<Result>(`${environment.apiUrl}/connector/Publishconnector?uid=${uId}`, uId);
  }
  //createtypes(type: types) {
  //  return this.http.post<Result>(`${environment.apiUrl}/connector/addauthenticationaype`, type);
  //}
  getAuthenticationTypeById(uId: string) {
    return this.http.get<types>(`${environment.apiUrl}/authentication/getauthenticationtype?uid=${uId}`);
  }
  addupdatetype(type: types) {
    return this.http.post<Result>(`${environment.apiUrl}/authentication/addupdateauthenticationtype`, type);
  }
  addupdateconfiguration(authconfig: authconfiguration) {
    return this.http.post<Result>(`${environment.apiUrl}/authentication/addupdateConfiguration`, authconfig);
  }
  getAuthenticationConfigurationById(uId: string) {
    return this.http.get<authconfiguration>(`${environment.apiUrl}/authentication/getauthenticationconfiguration?uid=${uId}`);
  }

  addupdateOauthTypeconfiguration(authtypeconfig: OauthTypeConfiguration) {
    return this.http.post<Result>(`${environment.apiUrl}/authentication/addupdateOauthypeconfiguration`, authtypeconfig);
  }

  getAuthenticationOauthConfigurationById(uId: string) {
    return this.http.get<OauthTypeConfiguration>(`${environment.apiUrl}/authentication/getauthenticationOauthconfiguration?uid=${uId}`);
  }
}
